import { zergApi } from "@/service/zerg";

class VehicleService {

    async getVehicleBrands(params) {
        try {
            const data = await zergApi.post("setting/vehicles/brands/get-vehicle-brands", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveVehicleBrand(params) {
        try {
            const data = await zergApi.post("setting/vehicles/brands/save-vehicle-brand", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async editVehicleBrand(params) {
        try {
            const data = await zergApi.post("setting/vehicles/brands/edit-vehicle-brand", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataBrandById(params) {
        try {
            const data = await zergApi.post("setting/vehicles/brands/get-data-brand-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVehicleTypes(params) {
        try {
            const data = await zergApi.post("setting/vehicles/types/get-vehicle-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataVehicleTypeById(params) {
        try {
            const data = await zergApi.post("setting/vehicles/types/get-data-vehicle-type-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveVehicleType(params) {
        try {
            const data = await zergApi.post("setting/vehicles/types/save-vehicle-type", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleBrands(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-brands", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleSettings(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-settings", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleTypes(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleModel(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-model", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleSuppliers(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-suppliers", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleContractTypes(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-contract-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listVehicleLoadCapacity(params) {
        try {
            const data = await zergApi.post("setting/vehicles/list-vehicle-load-capacity", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async createOrUpdateVehicle(params) {
        try {
            const data = await zergApi.post("setting/vehicles/create-or-update-vehicle", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async editVehicleType(params){
        try {
            const data = await zergApi.post("setting/vehicles/types/edit-vehicle-type", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVehicles(params){
        try {
            const data = await zergApi.post("setting/vehicles/get-vehicles",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVehicleById(params){
        try {
            const data = await zergApi.post("setting/vehicles/get-vehicle-by-id",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVehicleSettingsByServiceTypeAndClientId(params){
        try {
            const data = await zergApi.post("setting/vehicles/get-vehicle-settings-by-service-type-and-client-id",params);
            return data;
        } catch (error) {
            throw error;
        }
    }



}

export default new VehicleService();
